const UNEXPECTED_ERROR = 'Error unexpected';

const getMessageFromResponse = (response: object): string | null => {
  if (!response.hasOwnProperty('data')) return null;
  const data = (response as { data: object }).data;
  if (!data.hasOwnProperty('detail')) {
    if (data.hasOwnProperty('message')) return (data as { message: string }).message;
    return UNEXPECTED_ERROR;
  }
  const detail = (data as { detail: string | object[] }).detail;
  if (detail === 'Null values not allowed') return 'This element can\'t be deleted';
  if (typeof detail === 'string') return detail;
  if (!(Array.isArray(detail))) return null;
  if (detail.length === 0) return '';
  const firstDetail = detail[0];
  if (firstDetail.hasOwnProperty('msg')) return (firstDetail as { msg: string }).msg;
  if (firstDetail.hasOwnProperty('message')) return (firstDetail as { message: string }).message;
  if (firstDetail.hasOwnProperty('error')) return (firstDetail as { error: string }).error;
  return UNEXPECTED_ERROR;
};

const getMessageFromError = (error: unknown): string => {
  if (typeof error === 'string') return error;
  if (typeof error !== 'object' || !error) return UNEXPECTED_ERROR;
  if (error.hasOwnProperty('response')) {
    const response = getMessageFromResponse((error as { response: object }).response);
    if (response !== null) return response;
  } 
  if (error instanceof Error) return error.message;
  if (error.hasOwnProperty('message')) return (error as { message: string }).message;
  if (error.hasOwnProperty('toString')) return (error as { toString: () => string }).toString();
  if (!error.hasOwnProperty('response')) return UNEXPECTED_ERROR;
  return UNEXPECTED_ERROR;
};

export default getMessageFromError;
